import useAuth from '@/composables/useAuth';
import useRuntimeConfig from '@/composables/useRuntimeConfig';
import i18n from '@/config/i18n';
import { snackbarMessageKey } from '@/models/symbols/Snackbar';
import { useEventBus } from '@vueuse/core';
import axios from 'axios';
import { storageService } from './storage.service';

const devMode = false;
const setErrorMessage = (err: any) => {
	
	if (devMode) {
		err.message = err.toString();
	} else if (i18n.global.te(`errors.${err.response?.data?.code ?? 0}`)) {
		err.message = i18n.global.t(`errors.${err.response?.data?.code ?? 0}`);
	} else if (err.response?.data?.message) {
		err.message = err.response.data.message;
	} else if (err.response?.data) {
		err.message = err.response.data;
	} else {
		err.message = i18n.global.t('errors.undefined')
	}
}

const handleError = (err: any, bus: any) => {
	setErrorMessage(err);
	if (err.message) {
		bus.emit({
			type: "danger",
			message: err.message,
			id: Date.now().toString()
		})
	}
}

const baseApi = {
	init(): void {
		const { initializeRedirect } = useAuth();
		const bus = useEventBus(snackbarMessageKey);

		axios.interceptors.request.use((req: any) => {
			const token = storageService.getToken();

			if (token && !req.url.includes('wp-json')) {
				req.headers = { ...req.headers, ...{ 'authorization': token } };
			}

			return req;
		});

		axios.interceptors.response.use((res: any) => {
		
			const token = res.headers['www-authenticate'];

			if (token) {
				storageService.setToken(token);
			}
			
			return Promise.resolve(res);
		}, function (error: any) {
			
			if (error.response?.status === 419) {
				initializeRedirect();
			} else if (error.response?.status !== 404) {
				handleError(error, bus);
			}

			return Promise.reject(error);
		});
	},

	get<T>(endpoint: string, data: unknown = undefined, headers?: any, apiBaseUrl?: string): Promise<T> {
		const { getRuntimeConfig } = useRuntimeConfig();
		return new Promise<T>((resolve, reject) => {
			getRuntimeConfig()
				.then(x => (axios.get<T>(`${apiBaseUrl ?? x.apiBaseUrl}${endpoint}`, { data: data, headers: headers }))
					.then(result => resolve(result.data))
					.catch(err => {
						reject(err);
					}))
		})
	},

	post<T>(endpoint: string, data: unknown, headers?: any, apiBaseUrl?: string): Promise<T> {
	
		const { getRuntimeConfig } = useRuntimeConfig();
		return new Promise<T>((resolve, reject) => {
	
			getRuntimeConfig()
				.then(x => axios.post<T>(`${apiBaseUrl ?? x.apiBaseUrl}${endpoint}`, data, { headers : headers }))
				.then(result => resolve(result.data))
				.catch(err => {
					reject(err);
				})
		})
	}
}

export default baseApi;